import PropTypes from 'prop-types'
import React from 'react'
import CSSModules from 'react-css-modules'

import { MainButton } from 'components/button'
import { localize } from 'helpers/translator'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import LessonCodesList from 'components/lesson_codes_list/lesson_codes_list'

import styles from './lesson_codes.scss'

const LessonCodes = props => (
	<div styleName='wrapper'>
		<SecondaryTitle isCentered={true}>{localize('binders_lessonCodes_title')}</SecondaryTitle>
		<p styleName='subtitle'>{localize('binders_lessonCodes_subtitle')}</p>
		<LessonCodesList
			dateTitle={localize('binders_lessonCodes_sentColumn')}
			codeTitle={localize('binders_lessonCodes_pincodeColumn')}
			expirationTitle={localize('binders_lessonCodes_availableColumn')}
			isClickeable={false}
			codes={props.codes}
			actualTimestamp={props.actualTimestamp}
		/>
		<div styleName='btn-bar'>
			<div styleName='btn-container'>
				<MainButton onClick={props.closeModal}>{localize('global_close')}</MainButton>
			</div>
		</div>
	</div>
)

LessonCodes.propTypes = {
	lessons: PropTypes.object,
}

LessonCodes.defaultProps = {
	showType: false,
	showPrice: false,
}

export default CSSModules(
	LessonCodes, styles, {allowMultiple: true}
)
